import { render, staticRenderFns } from "./Caps.vue?vue&type=template&id=150cb517"
import script from "./Caps.vue?vue&type=script&lang=js"
export * from "./Caps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports